__turbopack_context__.v({
  "bucketHeader": "ForYou-module-scss-module__vPiEjW__bucketHeader",
  "forYouBucket": "ForYou-module-scss-module__vPiEjW__forYouBucket",
});
